/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import { AuthContextType } from '../types/Auth'

const initialState: AuthContextType = {
  auth: {},
  setAuth: () => {}
}
const storageItem = 'authContext-portal-analytics'
const localState = JSON.parse(localStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    localStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, ...newState }
}

export const AuthContext = createContext(initialState)

const AuthContextProvider: React.FC = (props: any) => {
  const [auth, setAuth] = useReducer(reducer, localState || initialState)
  useEffect(() => {
    localStorage.setItem(storageItem, JSON.stringify(auth))
  }, [auth])

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {props.children}
    </AuthContext.Provider>)
}

export default AuthContextProvider
